import type { IMeta } from "../Metas";
import { ERecurrencyType } from "../MyPlans/IMyPlans";
import type { IUser } from "../User";

export interface IProductComplete {
  product: IProduct;
  organization: IProductOrganization[];
  plan: IProductPlan[];
  user?: IUser;
}
export enum EPredictiveCategoryType {
  copom = "copom",
  dolar = "dolar",
  IBOV = "IBOV",
  acoes = "acoes",
}
export enum ECategoryType {
  CopyTrading = "CopyTrading",
}
export enum ESubcategoryType {
  daytrade = "daytrade",
  swingtrade = "swingtrade",
  wallets = "wallets",
}
export interface IProductOrganization {
  id: number;
  name: string;
  icon: string;
}

export interface IProductPlan {
  id: number;
  detailed_plain_description: string;
  price: number;
  qty_contract: number;
  active: boolean;
  name: string;
  vindi_id: string;
  payment_page: string;
  created_at: string;
  updated_at: string;
  isSelected?: boolean;
  recurrency_type: ERecurrencyType;
  qty_of_installments: number;
}

export interface IProduct {
  id: number;
  title: string;
  short_description: string;
  detailed_description: string;
  term_of_contract_id: string;
  category: ECategoryType;
  subcategory: ESubcategoryType;
  analyst_user: { name: string };
  analyst_user_id: number;
  analyst_user_name: string;
  analyst_broker_id: number;
  analyst_broker_account: string;
  analyst_certificate_nr: string;
  market: string;
  whitelabel_id: any;
  marketplace_type: number;
  emphasis: boolean;
  active: boolean;
  dashboard_analyst: boolean;
  dashboard_client: boolean;
  desktop: boolean;
  mobile: boolean;
  web: boolean;
  is_demo: boolean;
  is_real: boolean;
  photo_id: number;
  icon_id: number;
  platforms_id: number;
  type: string;
  created_at: string;
  updated_at: string;
  icon: string;
  photo: string;
  plans: IProductPlan[];
  instruments: IInstrument;
  organizations: IProductOrganization[];
  platforms: IPlatforms;
  term_of_contract: string;
  faq: IFaq[];

  // TODO: Verificar se será utilizado, atualmente tem no mock
  return?: string;
  partner?: {
    name: string;
    id: number;
    icon: {
      id: number;
      Location: string;
    };
  };
}
interface IPlatforms {
  id: number;
  windows: boolean;
  mac: boolean;
  android: boolean;
  chrome: boolean;
  firefox: boolean;
  opera: boolean;
  safari: boolean;
  edge: boolean;
  ios: boolean;
}

export interface IResponseProducts {
  data: IProductComplete[];
  meta: IMeta;
}

export interface IInstrument {
  count: number;
  symbols: string[];
}

interface IFaq {
  id: number;
  question: string;
  answer: string;
}
